import RightDrawer from "components/base/RightDrawer";
import SourceInfo from "./components/SourceInfo";
import { useSourceData } from "./hooks/use-source-data.hooks";
import { useEffect, useState } from "react";

export default function SourceSidebar() {
  const { isLoading, isSourceSidebarOpen, handleCloseSourceSidebar } =
    useSourceData();
  const [tourNext, setTourNext] = useState(null);

  useEffect(() => {
    if (!isLoading && tourNext != null) {
      setTimeout(() => {
        window.dispatchEvent(
          new CustomEvent(tourNext.action, { detail: tourNext.index })
        );
        setTourNext(null);
      }, 0);
    }
  }, [tourNext, isLoading]);

  useEffect(() => {
    function saveTourNextDetails({ detail }) {
      setTourNext(detail);
    }

    window.addEventListener("tour:app:sourcePanel:onLoad", saveTourNextDetails);

    return () => {
      window.removeEventListener(
        "tour:app:sourcePanel:onLoad",
        saveTourNextDetails
      );
    };
  }, []);

  return (
    <RightDrawer open={isSourceSidebarOpen} onClose={handleCloseSourceSidebar}>
      <SourceInfo tourNext={tourNext} />
    </RightDrawer>
  );
}
